export default __webpack_public_path__ + "static/sira-da76d5aa39971d464bcd75be5fa2985e.png";